var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpiTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.258 105.256V177.628H177.63V105.256H105.258ZM192.104 105.256V134.205H221.053V119.73H206.579V105.256H192.104ZM235.527 105.256V134.205H250.002V105.256H235.527ZM264.476 105.256V119.73H278.951V148.679H293.425V134.205H307.899V119.73H293.425V105.256H264.476ZM293.425 148.679V163.153H278.951V148.679H264.476V163.153H250.002V177.628H264.476V192.102H278.951V177.628H307.899V148.679H293.425ZM278.951 192.102V221.051H293.425V192.102H278.951ZM278.951 221.051H250.002V177.628H235.527V192.102H221.053V206.577H235.527V235.525H278.951V221.051ZM278.951 235.525V250H293.425V264.474H307.899V250H322.374V221.051H336.848V206.577H365.797V192.102H322.374V206.577H307.899V235.525H278.951ZM365.797 206.577V221.051H380.271V250H394.746V206.577V192.102H380.271V206.577H365.797ZM380.271 250H365.797V235.525H351.323V250H322.374V264.474H365.797V293.423H380.271V278.949H394.746V264.474H380.271V250ZM380.271 293.423V307.897H394.746V293.423H380.271ZM380.271 307.897H365.797V322.372H380.271V307.897ZM365.797 307.897V293.423H351.323V307.897H365.797ZM351.323 307.897H322.374V322.372H336.848V351.321H351.323V307.897ZM351.323 351.321V365.795H365.797V351.321H351.323ZM365.797 351.321H394.746V336.846H365.797V351.321ZM351.323 365.795H336.848V351.321H322.374V394.744H336.848V380.269H351.323V365.795ZM351.323 380.269V394.744H394.746V365.795H380.271V380.269H351.323ZM322.374 351.321V336.846H307.899V351.321H322.374ZM307.899 336.846V322.372H293.425V293.423H278.951V307.897H264.476V293.423H235.527V307.897H250.002V322.372H278.951V351.321H264.476V365.795H278.951V380.269H293.425V394.744H307.899V365.795H293.425V336.846H307.899ZM264.476 351.321V336.846H250.002V351.321H264.476ZM250.002 351.321H235.527V336.846H221.053V351.321H206.579V365.795H221.053V380.269H206.579V365.795H192.104V394.744H264.476V380.269H235.527V365.795H250.002V351.321ZM206.579 351.321V322.372H235.527V307.897H206.579V293.423H177.63V307.897H192.104V351.321H206.579ZM177.63 293.423V278.949H206.579V293.423H221.053V278.949H235.527V264.474H206.579V235.525H192.104V264.474H177.63V250H163.155V264.474H148.681V278.949H163.155V293.423H177.63ZM163.155 250V235.525H148.681V250H163.155ZM163.155 235.525H177.63V221.051H192.104V206.577H163.155V192.102H148.681V206.577H119.732V192.102H105.258V221.051H163.155V235.525ZM206.579 235.525H221.053V206.577H206.579V235.525ZM221.053 235.525V250H235.527V235.525H221.053ZM235.527 250V264.474H250.002V278.949H264.476V293.423H278.951V278.949V264.474H264.476V250H235.527ZM293.425 293.423H307.899V307.897H322.374V293.423H351.323V278.949H322.374V264.474H307.899V278.949H293.425V293.423ZM351.323 235.525V221.051H336.848V235.525H351.323ZM250.002 163.153V148.679H206.579V163.153H192.104V192.102H206.579V177.628H221.053V163.153H250.002ZM322.374 105.256V177.628H394.746V105.256H322.374ZM119.732 119.73H163.155V163.153H119.732V119.73ZM336.848 119.73H380.271V163.153H336.848V119.73ZM134.207 134.205V148.679H148.681V134.205H134.207ZM351.323 134.205V148.679H365.797V134.205H351.323ZM105.258 235.525V264.474H119.732V250H134.207V235.525H105.258ZM119.732 264.474V293.423H105.258V307.897H148.681V293.423H134.207V264.474H119.732ZM105.258 322.372V394.744H177.63V322.372H105.258ZM119.732 336.846H163.155V380.269H119.732V336.846ZM134.207 351.321V365.795H148.681V351.321H134.207Z",
    fill: "#F0FFF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.258 105.256V177.628H177.63V105.256H105.258ZM322.374 105.256V177.628H394.746V105.256H322.374ZM119.732 119.73H163.155V163.153H119.732V119.73ZM336.848 119.73H380.271V163.153H336.848V119.73ZM134.207 134.205V148.679H148.681V134.205H134.207ZM351.323 134.205V148.679H365.797V134.205H351.323ZM105.258 322.372V394.744H177.63V322.372H105.258ZM119.732 336.846H163.155V380.269H119.732V336.846ZM134.207 351.321V365.795H148.681V351.321H134.207Z",
    fill: "#F0FFF1"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 351,
    y1: 74.6067,
    x2: 425,
    y2: 74.6067,
    stroke: "#F0FFF1",
    strokeWidth: 13.2143
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 418.393,
    y1: 142,
    x2: 418.393,
    y2: 68,
    stroke: "#F0FFF1",
    strokeWidth: 13.2143
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 424.392,
    x2: 76,
    y2: 424.392,
    stroke: "#F0FFF1",
    strokeWidth: 13.2143
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 82.6071,
    y1: 357,
    x2: 82.6071,
    y2: 431,
    stroke: "#F0FFF1",
    strokeWidth: 13.2143
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -6.60714,
    x2: 74,
    y2: -6.60714,
    transform: "matrix(1 0 0 -1 351 417.785)",
    stroke: "#F0FFF1",
    strokeWidth: 13.2143
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -6.60714,
    x2: 74,
    y2: -6.60714,
    transform: "matrix(0 1 1 0 425 357)",
    stroke: "#F0FFF1",
    strokeWidth: 13.2143
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -6.60714,
    x2: 74,
    y2: -6.60714,
    transform: "matrix(-1 0 0 1 150 81.2139)",
    stroke: "#F0FFF1",
    strokeWidth: 13.2143
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -6.60714,
    x2: 74,
    y2: -6.60714,
    transform: "matrix(0 -1 -1 0 76 142)",
    stroke: "#F0FFF1",
    strokeWidth: 13.2143
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiTransfer);
export default __webpack_public_path__ + "static/media/upi_transfer.ad7e5a7c97d07bc844e5662c69ab233a.svg";
export { ForwardRef as ReactComponent };